import { render, staticRenderFns } from "./BannerInfos.vue?vue&type=template&id=2008c4d2&"
import script from "./BannerInfos.vue?vue&type=script&lang=js&"
export * from "./BannerInfos.vue?vue&type=script&lang=js&"
import style0 from "./BannerInfos.vue?vue&type=style&index=0&id=2008c4d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
